export default "__VITE_ASSET__i70lbmGX__"